module.exports = require('./timezones.json');


//////////////////
// WEBPACK FOOTER
// ./~/timezones.json/index.js
// module id = 293
// module chunks = 0